<template>
    <section class="advert-section">
        <div class="advert-container">
            <div class="advert-grids">
                <div class="advert-description">
                    <h2 class="title">From Compliance to Confidence</h2>
                    <p class="description">
                        Premium Tier goes further, adding identity verification and non-repudiation for complete trust
                        across teams, departments,
                        or organizations. It’s built for environments where security and accountability are
                        non-negotiable.
                        When you need airtight integrity and verifiable ownership of every asset action, Premium is the
                        clear choice.
                    </p>
                </div>
                <div class="advert-icon">
                    <svg viewBox="0 0 800 600" xmlns="http://www.w3.org/2000/svg">
                        <!-- Background -->
                        <rect width="800" height="600" fill="#ffffff" />

                        <!-- Verified identity symbol -->
                        <g transform="translate(400,250)">
                            <!-- User profile -->
                            <circle cx="0" cy="0" r="50" fill="#374151" stroke="#374151" stroke-width="3" />
                            <circle cx="0" cy="-12" r="20" fill="#ffffff" />
                            <path d="M-25,12 Q-25,0 0,0 Q25,0 25,12 L25,25 L-25,25 Z" fill="#ffffff" />

                            <!-- Verification badge -->
                            <circle cx="35" cy="-35" r="20" fill="#10b981" stroke="#10b981" stroke-width="3" />
                            <path d="M26,-38 L32,-32 L44,-44" stroke="#374151" stroke-width="4" stroke-linecap="round"
                                fill="none" />
                        </g>

                        <!-- Title -->
                        <text x="400" y="120" text-anchor="middle" font-family="Arial, sans-serif" font-size="32"
                            font-weight="bold" fill="#1e293b">
                            Premium Tier
                        </text>

                        <text x="400" y="150" text-anchor="middle" font-family="Arial, sans-serif" font-size="18"
                            fill="#64748b">
                            Identity Verification &amp; Non-Repudiation
                        </text>

                        <!-- Simple benefit -->
                        <text x="400" y="400" text-anchor="middle" font-family="Arial, sans-serif" font-size="16"
                            fill="#475569">
                            Verified users create undeniable records
                        </text>
                    </svg>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
// import SettingsIcon from "@/components/ui/icons/SettingsIcon.vue";
// import AdvertIcon from "@/components/ui/icons/AdvertIcon.vue";
export default {
    name: 'AdvertSection',
    components: {
        // SettingsIcon,
        // AdvertIcon,
    },
}
</script>

<style scoped>
.advert-section {
    background-color: #F9FAFB;
    padding: 64px 16px;
}

.advert-container {
    max-width: 72rem;
    margin: 0 auto;
    padding: 0px 16px;
}

.header {
    text-align: center;
    margin-bottom: 48px;
}

.title {
    font-size: 30px;
    font-weight: 700;
    color: #111827;
    margin-bottom: 16px;
}

.description {
    font-size: 18px;
    color: #4B5563;
    max-width: 768px;
    margin: 0 auto;
}

.advert-grids {
    display: grid;
    grid-template-columns: 1fr;
    gap: 48px;
    /* flex-direction: column; */
}

.advert-grid.right {
    background-color: #F9FAFB;
}

.advert-grid {
    padding: 64px 16px;
    /* display: grid; */
    /* gap: 48px; */
}

@media (min-width: 768px) {
    .advert-grids {
        grid-template-columns: 1fr 1fr;
        /* flex-direction: row; */
    }

    /* .advert-grid {
        grid-template-columns: 1fr 1fr;
    } */
}

.panel {
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    padding: 24px;
}

.panel-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 24px;
}

.icon {
    font-size: 24px;
    color: #9333EA;
}

.panel-title {
    font-size: 18px;
    font-weight: 600;
    color: #1F2937;
    margin-bottom: 0;
}

.settings-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.setting-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    background-color: #F9FAFB;
    border-radius: 8px;
}

.setting-label {
    font-size: 14px;
    color: #374151;
}

.toggle-switch {
    display: flex;
    align-items: center;
    width: 40px;
    height: 24px;
    background-color: #d1d5db;
    border-radius: 9999px;
    cursor: pointer;
}

.toggle-button {
    background-color: #374151;
    width: 1rem;
    height: 1rem;
    display: block;
    border-radius: 50%;
    margin-left: 0.2rem;
}

.color-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
}

.color-block {
    width: 100%;
    height: 80px;
    border-radius: 8px;
}

.color-block.purple {
    background-color: #9333EA;
}

.color-block.blue {
    background-color: #3B82F6;
}

.color-block.green {
    background-color: #10B981;
}

.color-block.red {
    background-color: #EF4444;
}
</style>